// The order-LINE edit's field set — shared by the SPA and the API.
//
// The three per-line inputs an operator may change on an order. Everything
// else on a line that moves with them (the extended volumes) and the order's
// volume totals are derived server-side; see
// apps/admin-api/src/services/order-line-edit.ts.
//
// Declared here, once, because the set crosses the API: the service validates
// against it and the SPA renders an input per entry. Two hand-written copies
// would drift (.claude/rules/code/no-magic-strings.md). `order-lines.test.ts`
// pins it to the policy's `order_details` section, so a field cannot become
// editable in one place and not the other.
//
// Browser-safe on purpose — imported by the SPA through
// `@commissions/auth/order-lines`, so it must not pull in `jose` or `fs`.
export const ORDER_LINE_EDITABLE_FIELDS = [
    'quantity',
    'business_volume_each',
    'commissionable_volume_each',
];
//# sourceMappingURL=order-lines.js.map